const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.MobXReact['org_hub_shell'];